import React from 'react';
import { Table } from 'antd';
import { NameOf, TableExpressions } from 'src/utils';
import { ColumnProps } from 'antd/lib/table';
import SummaryTypeDTO from 'src/models/generated/SummaryTypeDTO';
import TableColumnBuilder from 'src/utils/core/TableColumnBuilder';

export interface DisplayNameTableProps {
    data?: SummaryTypeDTO[];
    loading?: boolean;
    filterStrings: string[];
}

const SummaryTypeTable: React.FC<DisplayNameTableProps> = (props) => {

    const tableColumns: ColumnProps<SummaryTypeDTO>[] = [
        TableColumnBuilder.Create<SummaryTypeDTO>('name', 'Name')
            // .Width(400)
            .AddSorter('Text')
            .AddEnumFilterer(props.filterStrings, 'Exact Text')
            .AddRenderer('Ellipses')
            .Build(),
        TableColumnBuilder.Create<SummaryTypeDTO>('type', 'Type')
            // .Width(400)
            .AddSorter('Text')
            .AddTextFilterer()
            .AddRenderer('Ellipses')
            .Build(),
        TableColumnBuilder.Create<SummaryTypeDTO>('count', 'Count')
            // .Width(400)
            .AddSorter('Number')
            .AddTextFilterer()
            .AddRenderer('Ellipses')
            .Build(),
        TableColumnBuilder.Create<SummaryTypeDTO>('firstTransactionDate', 'First Transaction Date')
            // .Width(400)
            .AddSorter('Date')
            .AddDateFilterer()
            .AddRenderer('ShortDate', false)
            .Build(),
        TableColumnBuilder.Create<SummaryTypeDTO>('lastTransactionDate', 'Last Transaction Date')
            // .Width(400)
            .AddSorter('Date')
            .AddDateFilterer()
            .AddRenderer('ShortDate', false)
            .Build(),
        //TableColumnBuilder.Create<SummaryTypeDTO>('firstModifiedDate', 'First Modified Date')
        //    // .Width(400)
        //    .AddSorter('Date')
        //    .AddDateFilterer()
        //    .AddRenderer('ShortDate', false)
        //    .Build(),
        //TableColumnBuilder.Create<SummaryTypeDTO>('lastModifiedDate', 'Last Modified Date')
        //    // .Width(400)
        //    .AddSorter('Date')
        //    .AddDateFilterer()
        //    .AddRenderer('ShortDate', false)
        //    .Build(),
    ];

    return <>
        <Table
            rowKey={NameOf<SummaryTypeDTO>('id')}
            className='condensed-table striped-table'
            rowClassName={(record, index) => (index % 2 ? 'striped-row' : '')}
            loading={props.loading}
            pagination={false}
            columns={tableColumns}
            dataSource={props.data}
        />
    </>;
};

export default SummaryTypeTable;
